module.exports = __webpack_public_path__ + "static/media/wechat.e2efe92e.svg";